export default __webpack_public_path__ + "static/media/emo_judge_active.da275dbc.svg";